<div class="round" [style.width.px]="_diameter" [style.height.px]="_diameter">
  <div class="abs_center">{{text}}
  </div>
</div>
